<template>
  <div class="box4_main">
    <div class="title">IP广播</div>
    <div class="content">
      <div class="text1">设备总数<span>{{itemData.total}}</span></div>
      <img src="@/assets/home_images/box4/main.png">
      <div class="text2">
        <div class="text21"><span>{{itemData.online}}</span>在线</div>
        <div class="text22"><span>{{itemData.Offline}}</span>离线</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box4',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
    }
  }
};
</script>
<style lang='less' scoped>
.box4_main {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    font-size: 18px;
    line-height:30px;
    font-weight: normal;
    color:#fff;
    display: block;
    width:100%;
  }
  .content{
    position: absolute;
    padding-top:30px;
    width:100%;
    height:100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // align-items: center; 
    box-sizing: border-box;
    top:0;
    left:0;
    img{
      max-width: 57.7%;
      height:auto
    }
    span{
      font-size: 38px;
      font-weight: normal;
      margin: 0 3px;
      font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      font-style: normal;
    }
    .text1{
      display: flex;
      flex-direction: row;
      align-items: center; 
      color:#29abe2;
      font-size:16px;
    }
    .text2{
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .text21{
        display: flex;
        flex-direction: row;
        align-items: center; 
        color:#00a99d;
        font-size:16px;
        margin-top:14px;
      }
      .text22{
        display: flex;
        flex-direction: row;
        align-items: center; 
        color:#d22e5f;
        font-size:16px;
      }
    }
    
  }
  
}


</style>